import {
  SEARCH_FAILURE,
  SEARCH_HOLD_PAGER,
  SEARCH_INIT_PAGER,
  SEARCH_REQUEST,
  SEARCH_SUCCESS,
} from '../actions/search';

const valueForPage = (propName: string) => (
  value: any,
  page: any,
  state: Record<string, any>
): any => ({
  ...(state?.[propName] || {}),
  [page]: value,
});

const setLoadingValue = valueForPage('loading');
const setItemsValue = valueForPage('items');
const setErrorValue = valueForPage('error');

const request = (state: any = {}, action: any): any => ({
  ...state,
  loading: setLoadingValue(true, action.page, state),
});

const success = (state: any = {}, action: any): any => ({
  ...state,
  last: action.payload,
  items: setItemsValue(action.payload?.results || [], action.page, state),
  loading: setLoadingValue(false, action.page, state),
  error: setErrorValue(null, action.page, state),
});

const error = (state: any = {}, action: any): any => ({
  ...state,
  loading: setLoadingValue(false, action.page, state),
  error: setErrorValue(action.payload, action.page, state),
});

const localizeSearch = (state: Searches = {}, action: any): Searches => {
  const { key, type } = action;

  switch (type) {
    case SEARCH_REQUEST:
      return {
        ...state,
        [key]: request(state[key], action),
      };
    case SEARCH_SUCCESS:
      return {
        ...state,
        [key]: success(state[key], action),
      };
    case SEARCH_FAILURE:
      return {
        ...state,
        [key]: error(state[key], action),
      };
    case SEARCH_INIT_PAGER:
      return {
        ...state,
        [key]: {
          options: action.payload,
        },
      };
    case SEARCH_HOLD_PAGER:
      return {
        ...state,
        [key]: {
          disabled: true,
        },
      };
    default:
      return state;
  }
};

const search = (
  state: SearchesState = {},
  action: Record<string, any>
): SearchesState => {
  if (action.lang) {
    return {
      ...state,
      [action.lang]: localizeSearch(state?.[action.lang], action),
    };
  }
  return state;
};

export type Searches = Record<string, Record<string, any>>;
export type SearchesState = Record<string, Searches>;

export default search;
